import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastrService {
  messageService = inject(MessageService);
  translate = inject(TranslateService);

  success(message: string) {
    this.messageService.add({ severity: 'success', summary: this.translate.instant('Success'), detail: this.translate.instant(message) });
  }

  error(message: string) {
    this.messageService.add({ severity: 'error', summary: this.translate.instant('Error'), detail: this.translate.instant(message) });
  }

  warnin(message: string) {
    this.messageService.add({ severity: 'warn', summary: this.translate.instant('Warning'), detail: this.translate.instant(message) });
  }

  info(message: string) {
    this.messageService.add({ severity: 'info', summary: this.translate.instant('Info'), detail: this.translate.instant(message) });
  }

  custom(value: ToastMessageOptions) {
    this.messageService.add(value);
  }

}
